export function getBreadCrumbPaths(path: string): string[] {
  const matches = path.match(/\/[^\/]+/g)!;

  let seg = "";
  const result: string[] = [];
  matches.forEach((part) => {
    seg += part;
    result.push(seg);
  });

  return result;
}

export const validator = {
  email: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
  phone: /1\d{10}/,
};
